import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]

import AList from '@/components/atoms/AList.vue'
	import AInputText from '@/components/atoms/AInputText.vue'
	import AButtonPrimary from '@/components/atoms/AButtonPrimary.vue'

	import { ref, reactive, computed, watch } from 'vue'
	import { useGeneral } from '@/hooks'

	
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

	const { $t, $store, $router, $route, icons, loading, locale, setLocale } = useGeneral()

	const refFormLogin = ref()
	const refFormSignUp = ref()
	const window = ref('login')

	const windowValues = ['login', 'signup', 'reset-password']

	const state = reactive({
		title: 'Login_title_agro_html',
		subtitle: 'Login_subtitle',
		confirm_password: '',
		item: {
			person_name: '',
			customer_name: '',
			email: '',
			password: ''
		}
	})

	const titleSize = computed(() => {
		let size = 'text-h4'
		return size
	})

	const locales = computed(() => $store.getters['GET_LOCALES'])
	const varLocales = computed(() => $store.getters['GET_VAR_LOCALES'])
	// TODO: Fix .value.value??
	const localeText = computed(() => varLocales.value[locale.value.value])

	function init() {
		loading.value = false
	}
	init()

	function onClickLocale(lang: string) {
		setLocale(lang)
	}

	function toLogin() {
		$router.push({ name: 'login' })
		// state.title = 'Login_title_agro_html'
	}

	function toSignUp() {
		$router.push({ name: 'signup' })
		// state.title = 'Login_title_signup'
	}

	function toResetPasword() {
		$router.push({ name: 'reset-password' })
		// state.title = 'Login_title_reset_password'
	}

	function toWindow(route: string) {
		if (!windowValues.includes(route)) toLogin()
		else if (route !== window.value) {
			if (route === 'login') toLogin()
			if (route === 'signup') toSignUp()
			if (route === 'reset-password') toResetPasword()
			window.value = route
		}
	}

	watch($route, val => toWindow(val.name))

	if ($route.name === 'signup') toWindow($route.name)

	async function login() {
		const res = await refFormLogin.value.validate()
		const isValid = res.valid
		if (isValid) {
			loading.value = true
			await $store.dispatch('auth/login', { ...state.item })
			loading.value = false
		}
	}

	async function signup() {
		const res = await refFormSignUp.value.validate()
		const isValid = res.valid
		if (isValid) {
			loading.value = true
			const body = {
				user: {
					...state.item,
					locale: locale.value.value,
					phone_number: '',
					phone_prefix: ''
				},
				toLogin
			}
			await $store.dispatch('auth/signUp', body)
			loading.value = false
		}
	}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_app_bar, {
      flat: "",
      color: "grey-lighten-4 px-12",
      density: "comfortable"
    }, {
      default: _withCtx(() => [
        (window.value !== 'login')
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              icon: "",
              variant: "plain",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (toLogin()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  icon: _unref(icons)['arrowLeft']
                }, null, 8, ["icon"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_v_img, {
          src: require('@/assets/logo_horizontal_color.png')
        }, null, 8, ["src"]),
        _createVNode(_component_v_menu, { anchor: "bottom" }, {
          activator: _withCtx(({ props }) => [
            _createVNode(_component_v_btn, _mergeProps(props, { variant: "text" }), {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(localeText)) + " ", 1),
                _createVNode(_component_v_icon, {
                  icon: _unref(icons)['chevronDown']
                }, null, 8, ["icon"])
              ]),
              _: 2
            }, 1040)
          ]),
          default: _withCtx(() => [
            _createVNode(AList, {
              items: _unref(locales),
              onClick: onClickLocale
            }, null, 8, ["items"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_container, { class: "fill-height" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, {
          align: "center",
          justify: "center",
          class: "fill-height"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "6",
              lg: "10",
              xl: "5"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_window, {
                  modelValue: window.value,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((window).value = $event)),
                  touchless: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_window_item, { value: "login" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_form, {
                          ref_key: "refFormLogin",
                          ref: refFormLogin
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      class: "pb-6"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(_unref(titleSize)),
                                          innerHTML: _unref($t)(_unref(state).title)
                                        }, null, 10, _hoisted_1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, { cols: "12" }, {
                                      default: _withCtx(() => [
                                        _createVNode(AInputText, {
                                          label: _unref($t)('Login_input_email'),
                                          modelValue: _unref(state).item.email,
                                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).item.email) = $event)),
                                          "prepend-icon": _unref(icons)['email'],
                                          type: "email",
                                          required: "",
                                          onEnter: _cache[2] || (_cache[2] = ($event: any) => (login()))
                                        }, null, 8, ["label", "modelValue", "prepend-icon"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, { cols: "12" }, {
                                      default: _withCtx(() => [
                                        _createVNode(AInputText, {
                                          label: _unref($t)('password'),
                                          modelValue: _unref(state).item.password,
                                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(state).item.password) = $event)),
                                          "prepend-icon": _unref(icons)['password'],
                                          type: "password",
                                          required: "",
                                          onEnter: _cache[4] || (_cache[4] = ($event: any) => (login()))
                                        }, null, 8, ["label", "modelValue", "prepend-icon"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, { cols: "12" }, {
                                      default: _withCtx(() => [
                                        _createVNode(AButtonPrimary, {
                                          text: _unref($t)('Login_button_login'),
                                          block: "",
                                          large: "",
                                          onClick: _cache[5] || (_cache[5] = ($event: any) => (login()))
                                        }, null, 8, ["text"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      class: "text-center pt-6"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref($t)('Login_does_not_have_an_account')) + " ", 1),
                                        _createElementVNode("span", {
                                          class: "text-link text-success font-weight-bold",
                                          onClick: _cache[6] || (_cache[6] = ($event: any) => (toSignUp()))
                                        }, _toDisplayString(_unref($t)('Login_button_create_account')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 512)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_window_item, { value: "signup" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_form, {
                          ref_key: "refFormSignUp",
                          ref: refFormSignUp
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      class: "pb-6"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(_unref(titleSize)),
                                          innerHTML: _unref($t)(_unref(state).title)
                                        }, null, 10, _hoisted_2)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, { cols: "12" }, {
                                      default: _withCtx(() => [
                                        _createVNode(AInputText, {
                                          label: _unref($t)('person_name'),
                                          modelValue: _unref(state).item.person_name,
                                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(state).item.person_name) = $event)),
                                          "prepend-icon": _unref(icons)['person'],
                                          required: "",
                                          onEnter: _cache[8] || (_cache[8] = ($event: any) => (signup()))
                                        }, null, 8, ["label", "modelValue", "prepend-icon"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, { cols: "12" }, {
                                      default: _withCtx(() => [
                                        _createVNode(AInputText, {
                                          label: _unref($t)('customer_name'),
                                          modelValue: _unref(state).item.customer_name,
                                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(state).item.customer_name) = $event)),
                                          "prepend-icon": _unref(icons)['customer'],
                                          required: "",
                                          onEnter: _cache[10] || (_cache[10] = ($event: any) => (signup()))
                                        }, null, 8, ["label", "modelValue", "prepend-icon"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, { cols: "12" }, {
                                      default: _withCtx(() => [
                                        _createVNode(AInputText, {
                                          label: _unref($t)('email'),
                                          modelValue: _unref(state).item.email,
                                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(state).item.email) = $event)),
                                          "prepend-icon": _unref(icons)['email'],
                                          type: "email",
                                          required: "",
                                          onEnter: _cache[12] || (_cache[12] = ($event: any) => (signup()))
                                        }, null, 8, ["label", "modelValue", "prepend-icon"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, { cols: "12" }, {
                                      default: _withCtx(() => [
                                        _createVNode(AInputText, {
                                          label: _unref($t)('password'),
                                          modelValue: _unref(state).item.password,
                                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(state).item.password) = $event)),
                                          "prepend-icon": _unref(icons)['password'],
                                          type: "password",
                                          required: "",
                                          onEnter: _cache[14] || (_cache[14] = ($event: any) => (signup()))
                                        }, null, 8, ["label", "modelValue", "prepend-icon"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, { cols: "12" }, {
                                      default: _withCtx(() => [
                                        _createVNode(AInputText, {
                                          label: _unref($t)('General_confirm_password'),
                                          modelValue: _unref(state).confirm_password,
                                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(state).confirm_password) = $event)),
                                          "prepend-icon": _unref(icons)['password'],
                                          type: "password",
                                          required: "",
                                          "equal-to": _unref(state).item.password,
                                          onEnter: _cache[16] || (_cache[16] = ($event: any) => (signup()))
                                        }, null, 8, ["label", "modelValue", "prepend-icon", "equal-to"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, { cols: "12" }, {
                                      default: _withCtx(() => [
                                        _createVNode(AButtonPrimary, {
                                          text: _unref($t)('Login_button_login'),
                                          block: "",
                                          large: "",
                                          onClick: _cache[17] || (_cache[17] = ($event: any) => (signup()))
                                        }, null, 8, ["text"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      class: "text-center pt-6"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref($t)('Login_already_have_and_account')) + " ", 1),
                                        _createElementVNode("span", {
                                          class: "text-link text-success font-weight-bold",
                                          onClick: _cache[18] || (_cache[18] = ($event: any) => (toLogin()))
                                        }, _toDisplayString(_unref($t)('Login_login')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 512)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_window_item, { value: "reset-password" })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})